import React from 'react'
import Paper from '@mui/material/Paper';
import DialogContent from '@mui/material/DialogContent';
import Draggable from 'react-draggable';
import MasProductListContainer from '../../../../containers/common/form/modal/MasProductListContainer'
import BootstrapDialog, { BootstrapDialogTitle } from '../../dialog/BootstrapDialog'


function PaperComponent(props) {
    return (
        <Draggable
            handle="#draggable-product-dialog"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}

const MasProductModal = ({ title, handleClose, open, selectedProduct }) => {
    return (
        <BootstrapDialog
            open={open}
            onClose={handleClose}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-product-dialog"
            fullWidth={true}
            maxWidth="md"
        >
            <BootstrapDialogTitle style={{ cursor: 'move' }} id="draggable-product-dialog" onClose={handleClose}>
                {title}
            </BootstrapDialogTitle>
            <DialogContent dividers>
                <MasProductListContainer selectedProduct={selectedProduct} handleClose={handleClose} />
            </DialogContent>
        </BootstrapDialog>
    )
}

export default MasProductModal